'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _TermsContainer = require('./TermsContainer');

var _TermsContainer2 = _interopRequireDefault(_TermsContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _TermsContainer2.default;


//////////////////
// WEBPACK FOOTER
// ./lib/terms/index.js
// module id = 587
// module chunks = 0